let _token = null;

export function getToken() {
  return _token;
}

export function setToken(token) {
  _token = token;
}
